import React from "react";
import "./ProfilePage.scss";
import MyProfile from "../../UserProfile/MyProfile";

const ProfilePage = () => {
  return <MyProfile />;
};

export default ProfilePage;
